import styled from 'styled-components';

import _Table from 'xpi-black-ui/Common/Table';

export const Table = styled(_Table)`
  td, th {
    padding: 7px;

    input {
      width: 100px;
      outline: none;
      font-size: 14px;
      text-align: left;
      padding: 16px 8px;
      position: relative;
    }
  }

  tr {
    &:nth-child(even) td {
      background-color: inherit;
    }
  }

  td {
    height: 35px;
  }

  .SingleDatePicker .SingleDatePickerInput {
    min-width: 110px;
  }

  .SingleDatePicker .SingleDatePickerInput_calendarIcon {
    right: 8px;
    position: relative;
  }

  .CalendarMonth_table td {
    background-color: white;
  }

  .invisible {
    text-indent: -9999px;
  }

  .new-leg {
    transform: rotate(45deg);
  }
`;
